// client/src/hooks/useAnamnesesHistorico.js
import { useQuery } from '@tanstack/react-query';
import apiClient from '../services/api';
import useAlert from './useAlert';

const BASE_ROUTE = 'anamneses';
const QUERY_KEY = 'anamnesesHistorico';

// Listagem global de fichas de anamnese preenchidas (menu Documentos >
// Anamneses). Sem o parâmetro `cliente`, o backend já escopa pela account
// do usuário logado (ver server/controllers/anamneseController.js).
export const useAnamnesesHistorico = (params = {}, options = {}) => {
    const { setAlert } = useAlert();
    return useQuery({
        queryKey: [QUERY_KEY, params],
        queryFn: async () => {
            try {
                const { data } = await apiClient.get(`/${BASE_ROUTE}`, { params });
                return data.data || [];
            } catch (error) {
                const errorMsg = error.response?.data?.error || 'Erro ao carregar fichas de anamnese.';
                setAlert(errorMsg, 'danger');
                throw error;
            }
        },
        staleTime: 1000 * 30,
        ...options,
    });
};

export const useAnamneseHistoricoById = (id, options = {}) => {
    const { setAlert } = useAlert();
    return useQuery({
        queryKey: [QUERY_KEY, id],
        queryFn: async () => {
            try {
                const { data } = await apiClient.get(`/${BASE_ROUTE}/${id}`);
                return data.data || null;
            } catch (error) {
                const errorMsg = error.response?.data?.error || 'Erro ao carregar a ficha de anamnese.';
                setAlert(errorMsg, 'danger');
                throw error;
            }
        },
        enabled: !!id,
        ...options,
    });
};
